import React from 'react'
import { useIntl } from 'react-intl'
import MarkdownRender from 'LuxKit/MarkdownRender'
import HelpPane from 'components/Common/HelpPane'
import { getSupportEmailForCurrentRegion } from 'selectors/supportContactSelector'
import { connect } from 'react-redux'
import Modal from 'LuxKit/Modal/Modal'

interface Props {
  email: string
  description?: string
  currentContact: App.GeoContacts
}

function AdditionalGuestsModal({
  description,
  currentContact,
  email,
}: Props) {
  const intl = useIntl()
  return <Modal
    title={intl.formatMessage({
      id: 'ez8OYeH4km',
      defaultMessage: 'Extra Guest Surcharges',
      description: 'Modal title for extra guest surcharge information',
    })}
  >
    <MarkdownRender content={description || ''} />
    <HelpPane email={email} contactNumber={currentContact[currentContact.default]} />
  </Modal>
}
function mapStateToProps(state: App.State) {
  return {
    email: getSupportEmailForCurrentRegion(state),
  }
}

export default connect(mapStateToProps)(AdditionalGuestsModal)
